import { useEffect, Fragment } from 'react';
import { shape, bool } from 'prop-types';
import { CurrencyField, SelectField, CheckboxField, SplitDateField, RadioSwitchFields } from 'shared/fields';
import { Heading, LabelText } from 'shared/components';
import { InputsContainer, FlexContainer } from 'shared/containers';
import { periodOptions } from 'shared/config';
import {useNavigate} from "react-router-dom";

const PartnerForm = ({ values: {
  applicant_has_partner,
  partner_is_entrepreneur,
  partner_showPension,
}, settings: {entrepreneursModule}}) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/hypotheekbespaarcheck/partner');
  }, [navigate]);

  return <>
    <Heading>Je partner</Heading>
    <InputsContainer>
      <LabelText>Heb je een partner waarvan je het inkomen mee wilt rekenen?</LabelText>
      <RadioSwitchFields name="applicant_has_partner" />
      {applicant_has_partner && (
        <Fragment>
          <LabelText>Geboortedatum partner</LabelText>
          <SplitDateField name="partner_dob" />

          {entrepreneursModule ? (
            <>
              <LabelText>Is je partner ondernemer?</LabelText>
              <RadioSwitchFields name="partner_is_entrepreneur" />

              {!!partner_is_entrepreneur && (
                <Fragment>
                  <LabelText>Nettowinst {new Date().getFullYear() - 3}</LabelText>
                  <CurrencyField name="partner_entrepreneur_fiscal_profit_three_years_ago" placeholder="Bedrag" />
                  <LabelText>Nettowinst {new Date().getFullYear() - 2}</LabelText>
                  <CurrencyField name="partner_entrepreneur_fiscal_profit_two_years_ago" placeholder="Bedrag" />
                  <LabelText>Nettowinst {new Date().getFullYear() - 1}</LabelText>
                  <CurrencyField name="partner_entrepreneur_fiscal_profit_last_year" placeholder="Bedrag" />
                </Fragment>
              )}
            </>
          ) : null}

          {!partner_is_entrepreneur && (
            <Fragment>
              <LabelText>Bruto inkomen partner</LabelText>
              <FlexContainer>
                <CurrencyField name="partner_income" placeholder="Bedrag" />
                <SelectField
                  id="partner_income_period"
                  name="partner_income_period"
                  options={periodOptions}
                  placeholder="Per"
                />
              </FlexContainer>
              <FlexContainer>
                <CheckboxField id="partner_holiday_bonus" name="partner_holiday_bonus" label="Vakantiegeld?" />
                <CheckboxField id="partner_13th_month_salary" name="partner_13th_month_salary" label="13e maand?" />
              </FlexContainer>
            </Fragment>
          )}

          {partner_showPension && (
            <Fragment>
              <LabelText>Bruto AOW-inkomen partner</LabelText>
              <FlexContainer>
                <CurrencyField name="partner_pension_income" placeholder="Bedrag" />
                <SelectField
                  id="partner_pension_income_period"
                  name="partner_pension_income_period"
                  options={periodOptions}
                  placeholder="Per"
                />
              </FlexContainer>
            </Fragment>
          )}
        </Fragment>
      )}
    </InputsContainer>
  </>;
}

PartnerForm.propTypes = {
  values: shape({
    applicant_has_partner: bool,
    partner_is_entrepreneur: bool,
    partner_is_entrepreneur_for_three_years: bool,
    partner_showPension: bool,
  }).isRequired,
};

export default PartnerForm;
